import { deepCopy } from '../util/object';

/**
 * A wrapper for a wire object used for communication with the server.
 * The properties of the wireObject are typically underscored: i.e. wireObject.some_property.
 */
export default class WireObjectProxy {
  _wireObject = null;

  constructor(data) {
    this._wireObject = deepCopy(data) || {};
  }

  copy() {
    return new this.constructor(this._wireObject);
  }

  get wireObject() {
    return this._wireObject;
  }
}
